var acc = document.getElementsByClassName('accordion');
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function (e) {
    $('.panel').css('display', 'none');

    e.currentTarget.classList.toggle('active');

    var panel = e.currentTarget.nextElementSibling;

    if (panel) {
      //console.log("öncesi ",Array.from(e.currentTarget.classList).indexOf("active"))
      if (Array.from(e.currentTarget.classList).indexOf('active') > -1) {
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
      }
    }

    //console.log("sonrasi ",$(panel).css("display"))

    //console.log("panel",panel)
  });
}

const buttonAnimSecond = async () => {
  let normalText = $('button#open-info-btn span').not('.italic').not('.blank');
  let italicText = $('button#open-info-btn span.italic').not('.blank');

  let count = 0;

  let turnLoop = () => {
    if ($(italicText[count]) != undefined) {
      if ($(italicText[count]).length) {
        $(italicText[count]).css('visibility', 'hidden');
        $(normalText[count]).css('visibility', 'visible');
        //console.log($(normalText[count]));
      } else clearInterval(interv);
    } else {
      clearInterval(interv);
    }
    count++;
  };

  let interv = setInterval(turnLoop, 80);
};

const buttonAnimFirst = async () => {
  let normalText = $('button#open-info-btn span').not('.italic').not('.blank');
  let italicText = $('button#open-info-btn span.italic').not('.blank');

  let count = 0;

  let turnLoop = () => {
    if ($(normalText[count]) != undefined) {
      if ($(normalText[count]).length) {
        $(normalText[count]).css('visibility', 'hidden');
        $(italicText[count]).css('visibility', 'visible');
        //console.log($(normalText[count]));
      } else {
        //buttonAnimSecond();
        clearInterval(interv);
      }
    } else {
      //buttonAnimSecond();
      clearInterval(interv);
    }
    count++;
  };

  let interv = setInterval(turnLoop, 80);
};

$(document).ready(async function () {
  const productId = document.querySelector('#product-id').value;
  const cartLimitation = document.querySelector('#cart-limitation').value;
  // console.log("Doc Ready -");
  // console.log("productId :", productId);
  // console.log("cartLimitation :", cartLimitation);

  const getCart = async () => {
    const cartReq = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).catch((error) => {
      console.error('Error:', error);
    });
    if (!cartReq) return [];
    const cartObject = await cartReq.json();
    if (!cartObject) return [];
    // console.log("cart object :", cartReq);
    return cartObject;
  };
  const updateProductQtyCart = async (lineItemId, quantity) => {
    let updates = {};
    updates[lineItemId] = quantity;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };
  const getProductFromCart = async (productId) => {
    // console.log("getProductFromCart");
    const cartObject = await getCart();
    if (!cartObject) return [];
    const { items } = cartObject;
    if (!items?.length) return [];

    if (!productId?.length) return items;
    let targetItem;
    for (const item of items) {
      if (String(item?.product_id) == productId) {
        targetItem = item;
        break;
      }
    }

    if (!targetItem) return [];

    // console.log("targetItem :", targetItem);
    return targetItem;
  };
  const checkCartLimitation = async () => {
    // console.log('checkCartLimitation - ');

    document.querySelector('#limit-warning').style['display'] = 'none';
    const cartProduct = await getProductFromCart(productId);
    // console.log("checkCartLimitation - cartProduct", cartProduct);
    // console.log("checkCartLimitation - cartLimitation", cartLimitation);
    const cartLimitInput = document.querySelector('#cart-limit-enable');
    if (!cartProduct?.id) {
      cartLimitInput.value = 'allowed';
      // console.log("checkCartLimitation - check 1", "allowed");
      return true;
    }
    if (parseInt(cartLimitation) > 0) {
      if (cartProduct?.quantity > parseInt(cartLimitation)) {
        updateProductQtyCart(cartProduct?.id, parseInt(cartLimitation));
        cartLimitInput.value = 'full';
        document.querySelector('#limit-warning').style['display'] = 'block';
        return false;
      }
      if (cartProduct?.quantity === parseInt(cartLimitation)) {
        cartLimitInput.value = 'full';
        document.querySelector('#limit-warning').style['display'] = 'block';
        return false;
      }
    }

    // console.log("cartLimitInput : ", cartLimitInput);

    cartLimitInput.value = 'allowed';
    document.querySelector('#limit-warning').style['display'] = 'none';
    // console.log("checkCartLimitation - check 2", cartLimitInput.value);
    return true;
  };
  const checkCartLimitInput = () => {
    const cartLimitInput = document.querySelector('#cart-limit-enable')?.value;

    // console.log("checkCartLimitInput : ", cartLimitInput);
    if (cartLimitInput === 'allowed') {
      return true;
    }
    return false;
  };
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector('.js-go-cart-drawer-content');

  // Options for the observer (which mutations to observe)
  const config = { attributes: false, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        checkCartLimitation();
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  const targetNode2 = document.querySelector(
    '#product-slack-windows-info .size-panel'
  );

  const config2 = { attributes: false, childList: true, subtree: false };

  // Callback function to execute when mutations are observed
  const callback2 = (mutationList, observer2) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        console.log('A child node has been added or removed.');
      } else if (mutation.type === 'attributes') {
        console.log(`The ${mutation.attributeName} attribute was modified.`);
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer2 = new MutationObserver(callback2);

  // Start observing the target node for configured mutations
  observer2.observe(targetNode2, config2);

  checkCartLimitation();
  let sizeChangeForbidden = false;

  let windowed = false;
  let sizePen = false;
  let sizeSelected = false;

  // console.log(option_list_name);
  select = document.getElementById('colour-option');

  if (colourOption.length) {
    for (var i = 0; i <= colourOption.length; i++) {
      if (colourOption[i] != undefined) {
        var opt = document.createElement('option');
        opt.value = i;
        opt.innerHTML = option_list_name[i];
        select.appendChild(opt);
      }
    }
    $(select).change((elem) => {
      let numb = $('#colour-option option:selected').val();
      if (numb > -1) {
        location.href = colourUrl[numb];
      }
    });
  } else {
    if (document.getElementById('colour-option') !== null)
      document.getElementById('colour-option').disabled = true;
  }

  $(window).bind('mousewheel', function (e) {
    if ($(window).width() < $('.product-page-width').height()) {
      let mouseX = parseInt(e.pageX);
      let windowHalf = parseInt(window.innerWidth / 2);
      if ($('.product-page-width').height() < e.pageY) {
        $('#product-slack-windows-show').hide();

        $('#product-slack-windows').addClass('slack-lower');
      } else {
        $('#product-slack-windows-show').show();
        $('#product-slack-windows').removeClass('slack-lower');
      }

      if (mouseX < windowHalf) {
        if ($(window).width() > 639) {
          if (windowed == true) {
            windowed = false;
            $('#product-slack-windows-info')
              .removeClass('fadeInBottom')
              .addClass('fadeOutBottom');
            $('#open-info-btn').removeClass('opened');
          }
        }
      }
    }
  });

  if ($(window).width() < 640) {
    windowed = true;
    $('#open-info-btn').addClass('opened');
    $('#product-slack-windows-info')
      .removeClass('fadeOutBottom')
      .addClass('fadeInBottom');
  }

  $('#visual-add-to-cart-btn').click(async function (e) {
    const variantPrice = $(e.target).data('price');
    const variantType = $(e.target).data('variant-type');
    setTimeout(async () => {
      const limitationResult = await checkCartLimitation();

      if (!limitationResult && variantType !== 'giftcard') {
        $('#visual-add-to-cart-btn').addClass('disabled-checkout');

        document.getElementById('visual-add-to-cart-btn').disabled = true;
      }
    }, 1500);
  });

  $('a.size-options')
    .not('.out-of-stock')
    .click(async function (e) {
      $('a.size-options').removeClass('selected-option');

      sizeSelected = true;
      let newVariant = $(e.target).data('id');
      const variantPrice = $(e.target).data('price');
      const variantType = $(e.target).data('variant-type');
      if (variantType === 'giftcard') {
        $('.price-item>.money').html(
          `${new Intl.NumberFormat('en-US').format(variantPrice)}.00TL`
        );
      }

      let selectBox = $('.select.real .select__select');
      $('#form-selected-id').val(newVariant);

      $('product-form.product-form').css('display', 'block');
      $('#open-info-btn').css('display', 'none');
      $(e.target).addClass('selected-option');

      //console.log($(e.target).data("quantity"));
      // console.log("checkCartLimitInput() !!", checkCartLimitInput());
      // const checkCartLimitResponse=
      if (!checkCartLimitInput() && variantType !== 'giftcard') {
        console.log('INSIDE close !!');
        $('#visual-add-to-cart-btn').addClass('disabled-checkout');

        document.getElementById('visual-add-to-cart-btn').disabled = true;

        checkCartLimitation();
        return true;
      }
      if ($(e.target).data('quantity') == '0' && variantType !== 'giftcard') {
        $('#visual-add-to-cart-btn').addClass('disabled-checkout');

        document.getElementById('visual-add-to-cart-btn').disabled = true;
        //console.log("yokkk");
      } else {
        $('#visual-add-to-cart-btn').removeClass('disabled-checkout');

        document.getElementById('visual-add-to-cart-btn').disabled = false;
      }
      checkCartLimitation();
    });

  if ($(window).width() < 640) {
    sizePen = true;
    $('#close-size').removeClass('icon-opened').addClass('icon-closed');
    $('#open-size').removeClass('icon-closed').addClass('icon-opened');
    $('.size-hidden').addClass('open');

    //console.log($("#select-area-colour"));
    //console.log($("#select-area-size"));

    let elem = $('#select-area-colour>span');

    if (elem.html().trim() == '') {
      $('#select-area-colour').addClass('ignore-it');
      $('#select-area-size').addClass('widen-it');
      //console.log("içi boş");
    }

    //$("#close-size").removeClass("icon-opened").addClass("icon-closed") ;
  }

  $('div#select-area-size').click(function () {
    if (!sizeChangeForbidden) {
      if ($(window).width() > 639) {
        if (sizePen == true) {
          sizePen = false;

          $('#open-size').removeClass('icon-closed').addClass('icon-opened');

          $('#close-size').removeClass('icon-opened').addClass('icon-closed');
          $('.size-hidden').removeClass('open');
        } else if (sizePen == false) {
          sizePen = true;

          $('#close-size').removeClass('icon-closed').addClass('icon-opened');
          $('#open-size').removeClass('icon-opened').addClass('icon-closed');
          $('.size-hidden').addClass('open');
        }
      }
    }
  });

  $('#open-info-btn').hover(
    function () {
      buttonAnimFirst();
    },
    function () {
      // change to any color that was previously used.
      buttonAnimSecond();
    }
  );

  // console.log('TEST 1');
  $('#open-info-btn').click(function () {
    // console.log('TEST 2');
    if (windowed == false) {
      windowed = true;
      $('#open-info-btn').addClass('opened');
      $('#product-slack-windows-info')
        .removeClass('fadeOutBottom')
        .addClass('fadeInBottom');
    } else {
      if (sizePen == false) {
        sizePen = true;

        $('#close-size').removeClass('icon-closed').addClass('icon-opened');
        $('#open-size').removeClass('icon-opened').addClass('icon-closed');
        $('.size-hidden').addClass('open');
      }
    }
  });

  document.querySelector('#open-info-btn').addEventListener('mouseup', () => {
    $('#open-info-btn').html($('#open-info-btn').data('add-value'));
  });

  $(document).bind('mousewheel', function (e) {});

  $('div#product-slack-windows-show').click(function (e) {
    if (!$(e.target).closest('.button-area').length > 0) {
      if (windowed == false) {
        $('#open-info-btn').addClass('opened');
        windowed = true;
        $('#product-slack-windows-info')
          .removeClass('fadeOutBottom')
          .addClass('fadeInBottom');
      } else {
        windowed = false;
        $('#product-slack-windows-info')
          .removeClass('fadeInBottom')
          .addClass('fadeOutBottom');
        $('#open-info-btn').removeClass('opened');
      }
    }
  });

  let sizeOptions = $('.size-options');
  console.log('sizeOptions', sizeOptions);
  console.log('sizeOptions.html().trim()', sizeOptions.html().trim());
  if (
    sizeOptions.length == 1 &&
    (sizeOptions.html().trim() == 'Default Title' ||
      sizeOptions.html().trim() == 'One Size' ||
      sizeOptions.html().trim() == 'Tek Beden')
  ) {
    console.log('sizeOptions[0]', sizeOptions[0]);
    sizeSelected = true;

    let newVariant = $(sizeOptions[0]).data('id');

    //let selectBox=$(".select.real .select__select");
    $('#form-selected-id').val(newVariant);

    $('product-form.product-form').css('display', 'block');
    $('#open-info-btn').css('display', 'none');
    //$(e.target).addClass("selected-option");
    $('.size-selection-area').hide();

    $('.size-hidden').removeClass('open');
    $('#select-area-size').addClass('forbidden');
    $('#select-size-text').html(
      sizeOptions.html().trim() === 'Default Title' ? 'ONE SIZE' : ''
    );

    sizeChangeForbidden = true;
    setTimeout(() => {
      $(sizeOptions[0]).click();
    }, 1000);
  }
});

const targetNode = document.querySelector(
  '#product-slack-windows-info .size-panel'
);
console.log('targetNode', targetNode);
const config = { attributes: false, childList: true, subtree: false };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
  for (const mutation of mutationList) {
    if (mutation.type === 'childList') {
      document.querySelector('.mobile-grid .size-panel').innerHTML =
        document.querySelector(
          '#product-slack-windows-info .size-panel'
        ).innerHTML;
      console.log('A child node has been added or removed.');
    } else if (mutation.type === 'attributes') {
      console.log(`The ${mutation.attributeName} attribute was modified.`);
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
